import { portalAction, portalScreenContext } from '../../../app/telemetry/portalTelemetry';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { FileDto } from '../../../app/models/membership/fileDto';
import { formatBytes, getLocalDateWithTimeInString } from '../../../app/utils/util';
import { Box, Button, Grid } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';

interface Props {
    pcsEventDocument: FileDto;
    isSpaEditabe: boolean;
    downloadFile: (name: string) => void;
    setFileToDelete: (name: string) => void;
    setDeleteDocumentConfirmation: (isDelete: boolean) => void;
}

export default function EventDocumentsMediaCard({ pcsEventDocument, isSpaEditabe, downloadFile, setFileToDelete,
    setDeleteDocumentConfirmation }: Props) {
    return <Card sx={{ maxWidth: "98%", background: '#f3f3f3', height: '250px' }}>
        <CardContent sx={{ height: '96px' }}>
            <Box sx={{ minWidth: "100%" }}>
                <Grid container rowSpacing={4} sx={{ m: '2%' }}>

                    <Grid size={{ xs: 4 }}>
                        <Typography variant='body1'><b>File name</b></Typography>
                    </Grid>

                    <Grid size={{ xs: 8 }}>
                        <Typography variant='body1'>{pcsEventDocument.name}</Typography>
                    </Grid>

                    <Grid size={{ xs: 4 }}>
                        <Typography variant='body1'><b>File size</b></Typography>
                    </Grid>

                    <Grid size={{ xs: 8 }}>
                        <Typography variant='body1'>{pcsEventDocument.size && formatBytes(pcsEventDocument.size)}</Typography>
                    </Grid>

                    <Grid size={{ xs: 4 }}>
                        <Typography variant='body1'><b>Last modified</b></Typography>
                    </Grid>

                    <Grid size={{ xs: 8 }}>
                        <Typography variant='body1'>{pcsEventDocument.modifiedDate && getLocalDateWithTimeInString(new Date(pcsEventDocument.modifiedDate))}</Typography>
                    </Grid>

                    <Grid size={{ xs: 6 }} className="wordWrap">
                        <Button sx={{ "& .MuiButton-startIcon": { marginRight: "0px" } }} variant="outlined" startIcon={<DownloadIcon />}
                            onClick={portalAction(portalScreenContext('EventDocumentsMediaCard'), 'EventDocumentsMediaCard.onClick.downloadFile', () => pcsEventDocument?.name && downloadFile(pcsEventDocument?.name))} >
                            Download
                        </Button>
                    </Grid>

                    <Grid size={{ xs: 6 }} className="wordWrap">
                        <Button sx={{ "& .MuiButton-startIcon": { marginRight: "0px" } }} variant="outlined"
                            startIcon={<DeleteIcon />} onClick={portalAction(portalScreenContext('EventDocumentsMediaCard'), 'EventDocumentsMediaCard.onClick.setFileToDelete', () => {
                                pcsEventDocument?.name && setFileToDelete(pcsEventDocument?.name);
                                setDeleteDocumentConfirmation(true)
                            })} disabled={isSpaEditabe}>
                            Delete
                        </Button>
                    </Grid>
                </Grid>
            </Box>
        </CardContent>
    </Card>
}